export default __webpack_public_path__ + "static/media/909.e03288bf.png";